import { useEffect, useRef, useState } from "react";

const useCountUp = ({ start = 0, end, duration = 1, decimals = 0 }) => {
  const [value, setValue] = useState(start);
  const rafRef = useRef(null);

  useEffect(() => {
    const startTime = performance.now();
    const durationMs = duration * 1000;

    const animate = (now) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / durationMs, 1);

      setValue(start + (end - start) * progress);

      if (progress < 1) {
        rafRef.current = requestAnimationFrame(animate);
      }
    };

    rafRef.current = requestAnimationFrame(animate);

    return () => {
      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current);
      }
    };
  }, [start, end, duration]);

  return value.toFixed(decimals);
};

export default useCountUp;
